import { gql, ApolloClient } from '@apollo/client';
import { TLaunchDarklySet } from '../../../../store/LaunchDarkly';
import { TQueryResponse } from '../../../types';
import { client } from '../../graphql';
import { registrationClient } from '../../registration/registrationClient';

export const getUsStates = async (client: ApolloClient<any>) => {
  const { data } = await client.query<TQueryResponse<'salesforceUSStates', string[]>>({
    query: gql`
      query {
        salesforceUSStates
      }
    `,
  });
  return data;
};

export const getUsStatesForRegistration = async (launchDarkly: TLaunchDarklySet) => {
  return getUsStates(registrationClient(launchDarkly));
};

export const getUsStatesPostLogin = async (launchDarkly: TLaunchDarklySet) => {
  return getUsStates(client(launchDarkly));
};
